export default __webpack_public_path__ + "static/media/edit.315c3b88.svg";